import { createUseStyles } from 'react-jss';

import "@fontsource/lato/300.css";
import "@fontsource/oswald/400.css";
import { ITheme, vars } from '../theme';

const useStyle = createUseStyles((theme: ITheme) => ({
    '@global': {
        ':root': {
            [vars.typography.normal.size]: '20px',
            [vars.typography.headline.size]: '25px',
        },
        [theme.mediaQueries.mobile.max]: {
            ':root': {
                [vars.typography.normal.size]: '18px',
                [vars.typography.headline.size]: '20px',
            },
        },
        '*': {
            boxSizing: 'border-box',
        },
        body: {
            margin: 0,
            background: theme.palette.main.background,
            color: theme.palette.main.text,
            fontFamily: theme.typography.normal.family,
            fontSize: theme.typography.normal.size,
            fontWeight: theme.typography.normal.weight,
            backgroundImage: `url(${theme.palette.wallpaper})`,
            lineHeight: 2,

            [theme.mediaQueries.desktop.min]: {
                background: theme.palette.third.background,
                backgroundImage: 'none',
            },
        },
        'h1, h2, h3': {
            fontFamily: theme.typography.headline.family,
            fontWeight: theme.typography.headline.weight,
            color: theme.palette.main.headline,
            margin: 0,
            display: 'inline-block',
        },
        h1: {
            fontSize: theme.typography.headline.size,
        },
        h2: {
            fontSize: theme.typography.headline.size,
        },
    },
}));

const GlobalStyles = () => {
    useStyle();
    return null;
};

export default GlobalStyles;
